const projects = [
  {
    key: 'dhawa',
    theme: 'dhawa',
    value: 'Dhawa Phuket',
    logo: 'dhawa_180x120.png',
    thumbnail: 'thumb-dhawa.jpg',
    list: [
      {
        en: '1-2 bedroom stylish apartments with lagoon views in Laguna Phuket',
        ru: '1 и 2-спальные стильные апартаменты с видами на озеро в Laguna Phuket',
        cn: '普吉岛乐古浪一卧室和二卧室时尚湖景公寓',
      },
      {
        en: 'Managed by new hotel brand under Banyan Tree Group',
        ru: 'Под управлением нового отельного бренда группы компаний Banyan Tree',
        cn: '由悦榕旗下最新酒店品牌运营',
      },
      {
        en: 'Affordable investment opportunity',
        ru: 'Доступные инвестиционные возможности',
        cn: '经济实惠的投资机遇',
      }
    ],
  },
  {
    key: 'cassia-phuket',
    theme: 'cassia',
    value: 'Cassia Phuket',
    logo: 'cassia_phuket_new_180x120.png',
    thumbnail: 'cassia_phuket_thumb_2.jpg',
    list: [
      {
        en: '1-2 bed seaview apartments in the heart of Laguna Phuket',
        ru: '1-2 спальные апартаменты с видом на море, расположенные в самом сердце Laguna Phuket',
        cn: '1卧至2卧海景公寓，位于普吉岛乐古浪核心位置',
      },
      {
        en: 'A lifestyle investment with 5% guaranteed returns for 3 years',
        ru: '5% гарантированного дохода в течение 3 лет + возможность наслаждаться отдыхом',
        cn: '生活方式投资，前3年5％的年回报率',
      },
      {
        en: 'Construction completed',
        ru: 'Строительство завершено',
        cn: '项目竣工',
      }
    ],
  },
  {
    key: 'cassia-bintan',
    theme: 'cassia',
    value: 'Cassia Residences Bintan',
    logo: 'cassia_bintan_180x120.png',
    thumbnail: 'cassia_bintan_thumb_2.jpg',
    list: [
      {
        en: 'Affordable holiday homes, beachfront 1-2 bedroom apartments',
        ru: 'Доступные 1-2 спальные апартаменты на берегу моря',
        cn: '价格亲民的假日公寓, 一至二卧海景公寓',
      },
      {
        en: 'The newest property in the Laguna Bintan integrated complex',
        ru: 'Новый проект недвижимости в интегрированном комплексе Laguna Bintan',
        cn: '民丹岛乐古浪综合体最新物业',
      },
      {
        en: 'Investment returns with lifestyle benefits*',
        ru: 'Возврат инвестиций + преимущества проживания*',
        cn: '投资回报及生活方式福利兼得*',
      },
      {
        en: '*Terms and conditions apply',
        ru: '*Применяются условия и положения',
        cn: '*需满足一定条款和规则'
      }
    ],
  },
  {
    key: 'cassia-residences-phuket',
    theme: 'cassia',
    value: 'Cassia Residences Phuket',
    logo: 'cassia_phuket_180x120.png',
    thumbnail: 'thumb-cassia.jpg',
    list: [
      {
        en: '1-3 bedroom apartments in the heart of Laguna Phuket',
        ru: '1-3 спальные квартиры в самом сердце Laguna Phuket',
        cn: '位于普吉岛乐古浪核心区域的一卧至三卧公寓',
      },
      {
        en: 'Stunning water views adjacent to Cassia Phuket Hotel',
        ru: 'Потрясающие виды на озеро рядом с отелем Cassia Phuket',
        cn: '绝美水景，毗邻普吉岛悦梿酒店',
      },
      {
        en: 'Resort lifestyle with an array of multiple shopping, dining, and leisure facilities',
        ru: 'Курортный образ жизни с удобным доступом к магазинам, ресторанам и местам для отдыха',
        cn: '紧邻餐饮与购物中心',
      }
    ],
  },
  {
    key: 'park2',
    theme: 'laguna-park',
    value: 'Laguna Park 2 Phuket',
    logo: 'laguna_park2_180x120.png',
    thumbnail: 'thumb-park2.jpg',
    list: [
      {
        en: 'A choice of Standard and Deluxe homes',
        ru: 'Дома Стандартного и Делюкс типов на выбор',
        cn: '可选标准及豪华风格',
      },
      {
        en: 'Spacious living area in a gated environment',
        ru: 'Просторные жилые дома в закрытом комплексе',
        cn: '全天候安保社区里的宽敞居住环境',
      },
      {
        en: 'Complimentary membership to Laguna Golf Phuket*',
        ru: 'Членство в гольф-клубе Laguna Golf Phuket в качестве подарка*',
        cn: '普吉岛乐古浪高尔夫球场免费会员*',
      }
    ],
  },
  {
    key: 'angsana-oceanview',
    theme: 'angsana',
    value: 'Angsana Oceanview Residences',
    logo: 'angsana_ocean_180x120.png',
    thumbnail: 'thumb-angsana.jpg',
    list: [
      {
        en: '2 bedroom apartments, all with private pools',
        ru: '2-спальные апартаменты с собственным бассейном',
        cn: '双卧室含私人泳池公寓',
      },
      {
        en: 'Duplex penthouses with entertaining deck and pool on upper floor',
        ru: 'Двухуровневые пентхаусы с террасой и бассейном на крыше',
        cn: '複式单位带休憩甲板区及天台泳池',
      },
      {
        en: 'All apartments feature lagoon and seaviews',
        ru: 'Шикарный вид на озеро и море из каждых апартаментов',
        cn: '所有公寓以观湖和面海为特色',
      }
    ],
  },
  {
    key: 'laguna-village',
    theme: 'laguna',
    value: 'Laguna Village Residences',
    logo: 'laguna_village_180x120.png',
    thumbnail: 'thumb-laguna-village.jpg',
    list: [
      {
        en: 'Luxurious 4-bedroom residences with private swimming pool',
        ru: '4х спальные резиденции класса люкс с собственнм бассейном',
        cn: '豪华四卧私人泳池别墅',
      },
      {
        en: 'Perfectly positioned around tranquil lagoon',
        ru: 'Виллы, идеально расположенные вокруг уединенного озера',
        cn: '泻湖环绕，景致怡人',
      },
      {
        en: 'Discount and privileges within Laguna Phuket and Banyan Tree worldwide network*',
        ru: 'Скидки и привилегии в сети Banyan Tree по всему миру*',
        cn: '尊享普吉岛乐古浪内特权和折扣*',
      },
      {
        en: '*Terms and conditions apply',
        ru: '*Применяются условия и положения',
        cn: '*需满足一定条款和规则'
      }
    ],
  },
  {
    key: 'dusit',
    theme: 'dusit',
    value: 'Dusit Laguna Resort Villas Phuket',
    logo: 'dusit_180x120.png',
    thumbnail: 'thumb-dusit.jpg',
    list: [
      {
        en: '2-3 bedroom, 3-storey elegant waterfront villas with rooftop pool',
        ru: 'Элегантные 3-этажные виллы с 2-3-мя спальнями и собственным бассейном',
        cn: '两居及三居室三层湖景别墅，所有单位均设屋顶私人泳池',
      },
      {
        en: 'Providing rental returns on investment',
        ru: 'Возможность оправдать инвестиции за счет дохода с арендыВозможность оправдать инвестиции за счет дохода с аренды',
        cn: '在此投资可享受租金回报',
      },
      {
        en: 'Professionally managed by Dusit Thani Laguna Phuket',
        ru: 'Профессиональное управление Dusit Thani Laguna Phuket',
        cn: '由 普吉岛乐古浪都喜天丽酒店专业管理',
      }
    ],
  },
  {
    key: 'angsana-beachfront',
    theme: 'angsana',
    value: 'Angsana Beachfront Residences',
    logo: 'angsana_beachfront_180x120.png',
    thumbnail: 'thumb-angsana-beachfront.jpg',
    list: [
      {
        en: '2-3 bedroom condominiums on Bang Tao beach',
        ru: 'Квартиры с 2-3мя спальнями на пляже Банг Тао',
        cn: '邦涛海滩二至三卧公寓',
      },
      {
        en: 'Every unit features private pool and outdoor deck area',
        ru: 'Все апартаменты оснащены собственным бассейном и открытой террасой',
        cn: '每套海滨住宅均设有私人泳池与户外活动区',
      },
      {
        en: 'Managed by Angsana Laguna Phuket Resort',
        ru: 'Под управлением «Angsana Laguna Phuket Resort»',
        cn: '普吉岛乐古浪悦椿度假村负责管理',
      }
    ],
  },
  {
    key: 'banyantree',
    theme: 'banyantree',
    value: 'Banyan Tree Grand Residences',
    logo: 'logo-banyantree.png',
    thumbnail: 'thumb-banyantree.jpg',
    list: [
      {
        en: 'Elegant 3 and 5 bedroom waterfront pool villas',
        ru: 'Элегантные 3 и 5-спальные виллы с собственным бассейноми видом на озером',
        cn: '典雅三卧或五卧水景泳池别墅',
      },
      {
        en: 'Located Next to The Internationally Renowned Banyan Tree Phuket',
        ru: 'Расположены вблизи всемирно известного отеля Banyan Tree Phuket',
        cn: '紧邻国际著名度假村-悦榕庄',
      },
      {
        en: 'Contemporary residences with traditional Thai influence',
        ru: 'Современные виллы с чертами традиционной тайской архитектуры',
        cn: '当代住宅融合传统泰式风情',
      }
    ],
  }
]

export default projects


// WEBPACK FOOTER //
// ./src/data/PreviewTrip/project.js